import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import TcrLanding from "@/pages/TcrLanding";
import TrustedRelease from "@/pages/TrustedRelease";
import TcrReceipts from "@/pages/TcrReceipts";
import TcrArchitecture from "@/pages/TcrArchitecture";
import TcrDiagnostics from "@/pages/TcrDiagnostics";

function App() {
    return (
        <div className="App">
            <ErrorBoundary>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<TcrLanding />} />
                        <Route path="/release" element={<TrustedRelease />} />
                        <Route path="/receipts" element={<TcrReceipts />} />
                        <Route path="/architecture" element={<TcrArchitecture />} />
                        <Route path="/diagnostics" element={<TcrDiagnostics />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </ErrorBoundary>
        </div>
    );
}

class ErrorBoundary extends React.Component {
    state = { hasError: false };
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6">
                    <div
                        className="max-w-md rounded-sm border border-slate-200 bg-white p-8"
                        data-testid="app-error-boundary"
                    >
                        <h1 className="text-lg font-medium text-slate-900">
                            This view could not be loaded
                        </h1>
                        <p className="mt-2 text-sm leading-relaxed text-slate-600">
                            Please return to the overview or retry.
                        </p>
                        <div className="mt-5 flex items-center gap-3">
                            <button
                                onClick={() => window.location.reload()}
                                data-testid="app-error-retry-btn"
                                className="rounded-sm bg-blue-950 px-4 py-2 text-sm font-medium text-white hover:bg-blue-900"
                            >
                                Retry
                            </button>
                            <a
                                href="/"
                                data-testid="app-error-home-link"
                                className="text-sm text-blue-950 underline"
                            >
                                Return to overview
                            </a>
                        </div>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

export default App;
